import List from './List';
import Create from './Create';
import Edit from './Edit';

export const Device = {
  List,
  Create,
  Edit,
};
